export enum SideEnum {
  left = 'left',
  right = 'right',
}
